import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=489da85c&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=js&"
export * from "./EmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489da85c",
  null
  
)

export default component.exports